/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_JQ_74_81(e) {
  return (
    <li
      key={e.id}
      className={`text-(--error)`}
      children={[
        e.solicitante,
        ` (`,
        e.personas,
        `) — `,
        e.motivo ? `«${e.motivo}»` : `no dijo por qué`,
      ]}
    />
  );
}
